import { Injectable } from '@angular/core';
import { FlightAvailabilityToCheckin } from '@common/interface';
import {
  FlightAvailabilityToCheckinStore,
  resetFlightAvailabilityToCheckin,
  selectFlightAvailabilityToCheckinState,
  updateFlightAvailabilityToCheckin,
} from '@common/store';
import { Store, select } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class FlightAvailabilityToCheckinStoreService {
  constructor(private _store: Store<FlightAvailabilityToCheckinStore>) {}

  /**
   * 空席照会結果からの遷移情報を取得する
   * @returns 空席照会結果からの遷移情報を取得するObservable
   */
  getFlightAvailabilityToCheckinStatus$() {
    return this._store.pipe(select(selectFlightAvailabilityToCheckinState));
  }

  /**
   *空席照会結果からの遷移情報を更新する
   * @param data 空席照会結果からの遷移情報の更新値
   */
  updateFlightAvailabilityToCheckinStatus(data: FlightAvailabilityToCheckin) {
    this._store.dispatch(updateFlightAvailabilityToCheckin({ model: { ...data } }));
  }

  /**
   * 空席照会結果からの遷移情報をクリアする
   */
  public resetFlightAvailabilityToCheckin() {
    this._store.dispatch(resetFlightAvailabilityToCheckin());
  }
}
